// extracted by mini-css-extract-plugin
module.exports = {"editor_button":"Editor_editor_button__SLMIV","editor_editorWrapper":"Editor_editor_editorWrapper__BIevy"};